var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("\n        "+_vm._s(_vm.field.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }